import React, { memo, useState, useEffect } from 'react';
import { Grid, Card } from '@material-ui/core';
import logo from 'components/Logo/logo-dermpro.svg';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { Link } from 'react-router-dom';


const useStyles = makeStyles(() => ({
  textHyphenation: {
    hyphens: 'auto',
  },
  brandImage: {
    objectFit: 'cover',
  }
}));

const AffiliateBrands = ({results, debouncedSearchBrand}) => {
  const [searchResult, setSearchResult] = useState(results);
  const classes = useStyles();

  useEffect(() => {
    if (debouncedSearchBrand) {
      setSearchResult(results.filter((brand) =>
        brand.value.toLowerCase().includes(debouncedSearchBrand)
      ));
    } else {
      setSearchResult(results);
    }
  }, [debouncedSearchBrand, results]);

  return (
    <Grid container spacing={4}>
      {searchResult && searchResult.map((brand, idx) => {
        if (brand.option_id) {
          return (
            <Grid item md={2} sm={4} xs={6} key={idx}>
              <Link to={`/affiliates/${brand.option_id}`}>
                <Card elevation={25} className={clsx('text-center min-h-200')}>
                  <img
                    src={brand.image !== '' ? `${brand.image}` : logo}
                    alt={brand.value}
                    width="100%"
                    className={clsx('p-4 max-h-100', classes.brandImage)}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = logo;
                    }}
                  />
                  <p className={clsx('text-brand font-bold p-2 text-center min-h-60', classes.textHyphenation)}>{brand.value}</p>
                </Card>
              </Link>
            </Grid>
          );
        }

        return null;
      })}
    </Grid>

  );
};

function brandsPropsAreEqual(prevProp, nextProp) {
  return prevProp.results.length === nextProp.results.length
    && prevProp.debouncedSearchBrand === nextProp.debouncedSearchBrand;
}

export default memo(AffiliateBrands, brandsPropsAreEqual);
